import { useState } from "react";
import {
    Box,

    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Tab,
    Select,
    MenuItem,
    SelectChangeEvent,
} from "@mui/material";
import ReplyIcon from '@mui/icons-material/Reply';
import { useNavigate } from "react-router-dom";

import AddReply from "../../Modals/addReply";

const CustomerSupport = () => {
    const navigate = useNavigate();
    const [mainTab, setMainTab] = useState(0);
    const [subTab, setSubTab] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");

    const mainTabs = [
       
        "Queries Received",
        "Complaints / Disputes",
        "Booking Related Disputes",
    ];

    const subTabs = ["Pending", "Resolved"];

    const [supportData, setSupportData] = useState([
        {
            id: 1,
            user: "John Doe",
            email: "john@example.com",
            phone: "+91 9876543210",
            title: "App not loading",
            description: "The app freezes when I open it.",
            submittedDate: "20 Oct 2025",
            status: "Pending",
        },
        {
            id: 2,
            user: "Alice Smith",
            email: "alice@example.com",
            phone: "+91 9123456789",
            title: "Refund not processed",
            description: "I haven't received my refund yet.",
            submittedDate: "19 Oct 2025",
            status: "Resolved",
        },
        {
            id: 3,
            user: "Bob Williams",
            email: "bob@example.com",
            phone: "+91 9988776655",
            title: "Chat not connecting",
            description: "Unable to send or receive messages.",
            submittedDate: "18 Oct 2025",
            status: "Pending",
        },
    ]);

    // Handle Status Change
    const handleStatusChange = (index: number, event: SelectChangeEvent) => {
        const updatedData = [...supportData];
        updatedData[index].status = event.target.value;
        setSupportData(updatedData);
    };

    // Handle Tabs
    const handleMainTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setMainTab(newValue);
        setSubTab(0);
    };

    const handleSubTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setSubTab(newValue);
    };
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    // Filter Data Based on Subtab
    const filteredData = supportData.filter((item) =>
        subTab === 0 ? item.status === "Pending" : item.status === "Resolved"
    );

    return (
        <>
            <div className="main_title">
                <h1>Customer Support Management</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Customer Support
                </p>
            </div>
            <Box className="custom_tabs1">
                <Tabs
                    value={mainTab}
                    onChange={handleMainTabChange}
                    className="custom_tabs_links">
                    {mainTabs.map((label, index) => (
                        <Tab key={index} label={label} />
                    ))}
                </Tabs>
            </Box>
            <div className="cards">
                {/* Search Bar */}

                {/* Main Tabs */}

                {/* Sub Tabs */}
                <Box className="custom_tabs1 mt_20">
                    <Tabs
                        value={subTab}
                        onChange={handleSubTabChange}
                        className="custom_tabs_links"
                    >
                        {subTabs.map((label, index) => (
                            <Tab key={index} label={label} />
                        ))}
                    </Tabs>
                </Box>

                {/* Table */}
                <TableContainer className="table_container mt_20">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Sr. No.</TableCell>
                                <TableCell>User Details</TableCell>
                                <TableCell>Title</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Submitted Date</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredData.map((row, index) => (
                                <TableRow key={row.id} hover>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>
                                        <div className="user_block">
                                            <figure>
                                                <img src="/static/images/user_placeholder.png" alt="User" />
                                            </figure>
                                            <p>
                                                <b>{row.user}</b>
                                                {row.email}<br/>
                                                {row.phone}
                                            </p>
                                        </div>
                                    </TableCell>
                                    <TableCell>{row.title}</TableCell>
                                    <TableCell>{row.description}</TableCell>
                                    <TableCell>{row.submittedDate}</TableCell>
                                    <TableCell>
                                        <div className="form">
                                            <Select
                                                value={row.status}
                                                onChange={(e) => handleStatusChange(index, e)}
                                                size="small"
                                                fullWidth>
                                                <MenuItem value="Pending">Pending</MenuItem>
                                                <MenuItem value="Resolved">Resolved</MenuItem>
                                            </Select>
                                        </div>
                                    </TableCell>
                                    <TableCell>
                                        <div className="table_actions v2">
                                            <Box>
                                                <IconButton onClick={() => setOpenModal(true)}>
                                                    <ReplyIcon />
                                                </IconButton>
                                            </Box>
                                            <Box>
                                                <IconButton>
                                                    <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                                </IconButton>
                                            </Box>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}

                            {filteredData.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={7} align="center">
                                        No records found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <AddReply
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}             />
        </>
    );
};

export default CustomerSupport;
